import * as React from 'react'
import RedirectPage from 'redirectPage'
import barcodesReportImage from 'images/barcodes-report.png'
import { useTranslation } from 'translations'

const EMAIL_TAB_NODE_ID = '5xCrsM0cH0'

interface EmailsReportPageProps {
    accountSlug: string
}

const EmailsReportPage = ({ accountSlug }: EmailsReportPageProps) => {
    const { t } = useTranslation()
    return (
        <RedirectPage
            oldPageTitle={t('reports.emails.oldPageTitle')}
            newPageTitle={t('reports.redirect.marketingReport')}
            action={t('reports.redirect.isNowPartOf')}
            image={barcodesReportImage}
            link={`/account/${accountSlug}/reports/marketing#${EMAIL_TAB_NODE_ID}`}
        />
    )
}

export default EmailsReportPage
